<template>
<body style="background-color:#D6D6D6; background-size:cover">
    <div id="manuales">

        <v-container>
            <!--<h1 class="pl-5 ml-4 pt-5 hidden-xs-only" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>
            <h1 class="pl-5 ml-1 pt-5 hidden-sm-and-up" style="color:#942C75; font-family:Poppins; font-size:4vw; font-weight:500">{{title}}</h1>-->
            <ContentManuales :files="manuales">
            </ContentManuales>
            <!--<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
            <div class="hidden-lg-only"><br><br><br></div>
            <div v-show="$vuetify.breakpoint.sm"><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br></div>
            <div v-show="$vuetify.breakpoint.md"><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br></div>
            <div v-show="$vuetify.breakpoint.xl"><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br></div>-->
       </v-container>
         

    </div>
    </body>
</template>


<script>
import ContentManuales from "@/components/ContentManuales.vue"

export default {
   
    components:{
       ContentManuales
     },

    data(){
        return{
            title:"MANUALES",
            manuales:[
          
          {title:"Manual de la Educadora",img:"blanco.png",url:"../descargas/files/manuales/Manual_Educadora_2020.pdf",namedownload:"Manual_Educadora"},
          {title:"Manual Mundo Lalabum",img:"blanco.png",url:"../descargas/files/manuales/MANUAL_DE_USUARIO_DE_MUNDO_LALABUM_2019.pdf",namedownload:"Manual_Mundo_Lalabum"},
         
          
        ]
        }
    }
}
</script>

<style scoped>

</style>


